module.exports = __webpack_public_path__ + "static/media/co-next_icon.23d05848.jpg";